module.exports = __webpack_public_path__ + "static/Dryad-6ee3a9fc53d43971e97d13c13d0d26b2.jpg";